// @flow

import _ from 'lodash';
import Store from './Store';
import {
  ASSET_FILTERS,
  BREADCRUMB_ASSETS,
  COMMENT_FILTER_BY,
  COMMENTS,
  GLOBAL_PROGRESS,
  SUCCESS_DIALOG_MSG,
  TOAST
} from './Constants';
import {CommentFilterOption} from '../util/Constants';
import {AnnotationThread, FileFilters, RepoItem} from '../autogenerated/ZoomBridge';
import HashMap from '../protocol/HashMap';
import SaveSettings from "../queries/settings/SaveSettings";

export function toast(msg: string) {
  Store.put(TOAST, msg);
}

export function successToast(msg: string) {
  Store.put(SUCCESS_DIALOG_MSG, msg);
}

export function showSuccessMsg(msg: string) {
  if (SaveSettings.getBoolean("SHOW_STATUS_ALERT"))
    successToast(msg);
  else
    toast(msg);
}

export function getFilteredComments(comments: AnnotationThread[]) {
  if (!comments) {
    comments = Store.get(COMMENTS);
  }

  const filter = Store.get(COMMENT_FILTER_BY);

  let filteredComments;
  if (filter === CommentFilterOption.RESOLVED) {
    filteredComments = comments.filter((c) => c.isResolved());
  } else if (filter === CommentFilterOption.UNRESOLVED) {
    filteredComments = comments.filter((c) => !c.isResolved());
  } else {
    filteredComments = [...comments];
  }

  return filteredComments;
}

export function setGlobalProgress(globalProgress: boolean) {
  Store.put(GLOBAL_PROGRESS, globalProgress);
}

export function getRemotePathFromBreadcrumb() {
  const assets: RepoItem[] = Store.get(BREADCRUMB_ASSETS) || [];
  const paths = assets.map((a, i) => {
    if (i === 0) {
      return a.getRemotePath();
    }

    return a.getName();
  });
  return paths.join('/');
}

/**
 * Toggles the given filter and updates ASSET_FILTERS store entry.
 */
export function setAssetFilters(filterLabel: string) {
  let fileFilters: FileFilters = _.cloneDeep(Store.get(ASSET_FILTERS));
  if (!fileFilters) {
    fileFilters = new FileFilters().setFileTypes([]);
  }
  let filterMap: HashMap = fileFilters.getFilter2ValueMap();
  if (!filterMap) {
    fileFilters.setFilter2ValueMap((filterMap = new HashMap()));
  }
  if (filterMap.containsKey(filterLabel)) {
    filterMap.remove(filterLabel);
  } else {
    filterMap.put(filterLabel, true);
  }

  Store.put(ASSET_FILTERS, fileFilters);
}

/**
 * Clears ASSET_FILTERS store entry.
 */
export function clearAssetFilters() {
  const fileFilters = new FileFilters().setFileTypes([]).setFilter2ValueMap(new HashMap());
  Store.put(ASSET_FILTERS, fileFilters);
}
